import React from 'react'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import useStyles from './BarcodeLabelFileUploader.styles'

function BarcodeLabelFileUploader(props) {
  const classes = useStyles()
  const [file, setFile] = React.useState(props.item.image || null)
  const inputFile = React.useRef(null)

  function handleChange(event) {
    let item = props.item
    var reader = new FileReader()
    setFile(URL.createObjectURL(event.target.files[0]))
    reader.readAsBinaryString(event.target.files[0])
    item.name = event.target.files[0].name
    reader.onload = function() {
      item.image = `data:image/png;base64,${btoa(reader.result)}`
      props.onChange(item)
    }
  }

  return (
    <React.Fragment>
      {!file && (
        <React.Fragment>
          <CloudUploadIcon className={classes.icon} onClick={() => inputFile.current.click()} />
          <input
            type="file"
            accept="image/*"
            ref={inputFile}
            style={{display: 'none'}}
            onChange={handleChange}
          />
        </React.Fragment>
      )}
      {file && <div className={classes.image} style={{backgroundImage: `url(${file})`}}></div>}
    </React.Fragment>
  )
}

export default BarcodeLabelFileUploader
